import {
  IsNotEmpty,
  IsOptional,
  IsBoolean,
  IsNumber,
  IsIn,
  ValidateNested,
} from "class-validator";
import { Type } from "class-transformer";

import { AddressDto } from "../common";

export class HotelCoordinatesDto {
  @IsNumber()
  lat: number;

  @IsNumber()
  lng: number;
}

export class EventHotelDto {
  @IsNotEmpty()
  name: string;

  @ValidateNested()
  @Type(() => AddressDto)
  address: AddressDto;

  @IsOptional()
  phone?: string;

  @IsOptional()
  website_url?: string;

  @IsBoolean()
  has_special_rate: boolean;

  @IsOptional()
  @IsNumber()
  rate?: number;

  @IsOptional()
  @IsNumber()
  distance_value?: number;

  @IsOptional()
  @IsIn(["mi", "km"])
  distance_unit?: "mi" | "km";

  @IsOptional()
  @ValidateNested()
  @Type(() => HotelCoordinatesDto)
  coordinates?: HotelCoordinatesDto;
}
